import React from "react";
import { HomeTableCells } from "../../Cells";

export const ParsedTableDataContext = React.createContext<HomeTableCells.RowDataType[]>([]);
